import { Box, Divider, Grid, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { Translate } from 'react-localize-redux'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min'
import { track } from 'utils/segmentTracking'
import { Snackbars as Snackbar } from 'components'
import PropTypes from 'prop-types'
import { teams as teamsModule } from 'redux/modules'
import FilterNoneOutlinedIcon from '@material-ui/icons/FilterNoneOutlined'
import AddNewPlayer from 'containers/AddNewPlayer'
import useTeamFeature from 'hooks/useTeamFeature'
import PlayerDialog from 'containers/AddNewPlayer/components/PlayerDialog'
import { createTeamPlayerInOrganization } from 'containers/AddNewPlayer/api'
import useStyles from '../styles'
import { team as teamEvent } from 'constants/trackeventsname'
import TEAM_FEATURE_FLAGS from 'constants/teamFeatureFlags'

const Player = ({ team, fetchInviteUrl }) => {
  const classes = useStyles()
  const [deepLink, setDeepLink] = useState('Loading...')
  const [snackbar, setSnackbar] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)

  const { enabled: accessClubPersons } = useTeamFeature(
    TEAM_FEATURE_FLAGS.access_club_persons
  )

  useEffect(() => {
    fetchInviteUrl(team.uuid).then(({ response: { data } }) => {
      setDeepLink(data.url)
    })
  }, [])

  const handleLinkClick = (e) => {
    e.preventDefault()
    navigator.clipboard.writeText(deepLink)

    setSnackbar({
      message: <Translate id="team-invite.link-copied" />,
      success: true,
    })

    track(teamEvent.team_players_invite_link_copy, {
      team_id: +team.id,
      category: teamEvent.team,
    })
  }
  const [selectedMember, setSelectedMember] = useState(null)
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    position: 'midfield',
    number: '',
  })
  const [isNewPlayer, setIsNewPlayer] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [searchOpen, setSearchOpen] = useState(false)

  const handleSearchValue = (value) => {
    setSearchValue(value)
  }

  const handleAddClick = (member) => {
    setOpenDialog(true)
    setErrorMessage(null)

    if (member) {
      setSelectedMember(member)
      setIsNewPlayer(false)
      setFormData({
        firstName: member.first_name || '',
        lastName: member.last_name || '',
        position: member.position || 'midfield',
        number: member.number || '',
      })
    } else {
      setSelectedMember(null)
      setIsNewPlayer(true)
      setFormData({
        firstName: searchValue.trim() || '',
        lastName: '',
        position: 'midfield',
        number: '',
      })
    }

    setSearchOpen(false)
    setSearchValue('')
  }

  const handleDialogClose = () => {
    setOpenDialog(false)
    setSelectedMember(null)
    setSearchOpen(false)
    setSearchValue('')
  }

  const handleCreatePlayer = () => {
    setIsLoading(true)
    const payload = {
      pde_uuid: selectedMember?.uuid || null,
      position: formData.position,
      number: formData.number,
    }

    if (!selectedMember) {
      payload.first_name = formData.firstName
      payload.last_name = formData.lastName
    }

    createTeamPlayerInOrganization(team.uuid, payload)
      .then(() => {
        setSearchValue('')
        setOpenDialog(false)
        setSelectedMember(null)
        setFormData({
          firstName: '',
          lastName: '',
          position: 'midfield',
          number: '',
        })
      })
      .catch((error) => {
        if (error.response && error.response.status === 409) {
          setErrorMessage(error.response.data.message)
        }
        if (
          error.response &&
          error.response.status === 422 &&
          error.response.data?.errors
        ) {
          const messages = Object.values(error.response.data.errors).flat()
          const validationErrors = messages.join(', ')
          setErrorMessage(validationErrors)
        }
        console.error('Error creating player:', error)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const handleChange = (event) => {
    const { name, value } = event.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  return (
    <>
      {openDialog && (
        <PlayerDialog
          open={openDialog}
          onClose={handleDialogClose}
          handleCreatePlayer={handleCreatePlayer}
          handleChange={handleChange}
          formData={formData}
          isNewPlayer={isNewPlayer}
          isLoading={isLoading}
          errorMessage={errorMessage}
        />
      )}
      <Box p={2.5}>
        {accessClubPersons && (
          <>
            <Grid container item xs={12}>
              <Grid item xs={12}>
                <Box mb={1.5}>
                  <Typography variant="body2">
                    <Translate id="team.members.search-for-player" />
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <AddNewPlayer
                  handleAddClick={handleAddClick}
                  openDialog={openDialog}
                  searchOpen={searchOpen}
                  onSearchValueChange={handleSearchValue}
                  setSearchOpen={setSearchOpen}
                  onClose={handleDialogClose}
                  setSearchValue={setSearchValue}
                  searchValue={searchValue}
                />
              </Grid>
            </Grid>
            <Box
              display="flex"
              alignItems="center"
              style={{ margin: '4rem 0 2rem' }}
            >
              <Divider style={{ flexGrow: 1 }} />
              <Typography
                variant="body2"
                color="textSecondary"
                style={{ margin: '0 8px' }}
              >
                <Translate id="team.members.or" />
              </Typography>
              <Divider style={{ flexGrow: 1 }} />
            </Box>
          </>
        )}
        <Grid item xs={12}>
          <Typography
            variant="h3"
            component="h3"
            className={classes.invitationLink}
          >
            <Translate id="team-invite.send-link-title" />
          </Typography>
          <Typography variant="h6" component="h6" paragraph>
            <Translate id="team-invite.send-link-subtitle" />{' '}
            <Typography variant="body2">&quot;{team.name}&quot;</Typography>
          </Typography>
          <Box
            width="100%"
            mb={1}
            display="flex"
            alignItems="center"
            onClick={handleLinkClick}
            role="button"
          >
            <a href={deepLink} className={classes.deepLink}>
              {deepLink}
              <FilterNoneOutlinedIcon
                fontSize="inherit"
                className={classes.copyIcon}
              />
            </a>
          </Box>
        </Grid>
      </Box>
      {snackbar && <Snackbar {...snackbar} />}
    </>
  )
}

Player.propTypes = {
  team: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    organization_uuid: PropTypes.string,
  }).isRequired,
  fetchInviteUrl: PropTypes.func.isRequired,
}

export default compose(
  withRouter,
  connect(
    ({ team }) => ({
      team,
    }),
    {
      fetchInviteUrl: teamsModule.fetchInviteUrl,
    }
  )
)(Player)
